import { useQuery } from "@tanstack/react-query";
import { generateHookExports } from "api/generateExports";
import { createCRUDService } from "api/queryService";
import { API_CONFIG } from "services/apiConfig";
import axios from "../axios";

let subQueryData = API_CONFIG.PRODUCT_DESCRIPTION.parts?.find(
  (item) => item?.queryKey === "product-list",
);
let baseData = `${API_CONFIG.PRODUCT_DESCRIPTION?.path}/${subQueryData?.url}`;

const BASE_URL = baseData;
const QUERY_KEY = subQueryData?.queryKey;

const productListService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
  custom: {
    getAllByType: (params = {}, options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: () =>
          axios
            .get(`${BASE_URL}/all-by-types`, { params })
            .then((res) => res.data.data),
        ...options,
        retry: options.retry ?? 1,
        refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,
        onError: (error) => {
          showToast(error?.data);
        },
      });
    },
    getFields: (options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY],
        queryFn: async () => {
          const res = await axios.get(`${BASE_URL}/get-fields`, {
            params: { isProductDescription: true },
          });
          return res.data ?? {};
        },
        refetchOnWindowFocus: false,
        enabled: options.enabled ?? true,
        onError: (error) => {
          triggerToast(error?.data);
        },
      });
    },
    getFilteredDocs: (params = {}, options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY],
        queryFn: async () => {
          const res = await axios.get(`${BASE_URL}/get-filtered-docs`, {
            params,
          });
          return res.data ?? {};
        },
        refetchOnWindowFocus: false,
        enabled: options.enabled ?? true,
        onError: (error) => {
          triggerToast(error?.data);
        },
      });
    },
  },
});

export const {
  productListList,
  productListCreate,
  productListGetById,
  productListUpdate,
  productListUpdateSpecific,
  productListDownload,
  productListDelete,
  productListCount,
  productListGetAllByType,
  productListGetFields,
  productListGetFilteredDocs,
} = generateHookExports(productListService, "productList");
